export const LOGO_TYPE_DESKTOP = "desktop";
export const LOGO_TYPE_MOBILE = "mobile";

export type CustomerLogoType =
  | typeof LOGO_TYPE_DESKTOP
  | typeof LOGO_TYPE_MOBILE;

export const DEFAULT_LOGO_MOBILE =
  "https://checkout.volt.io/images/logo-secondary-dark.svg";
export const DEFAULT_LOGO_DESKTOP =
  "https://checkout.volt.io/images/logo-primary.svg";

export const defaultLogo = {
  [LOGO_TYPE_MOBILE]: DEFAULT_LOGO_MOBILE,
  [LOGO_TYPE_DESKTOP]: DEFAULT_LOGO_DESKTOP,
};

export type CustomerLogos = Partial<typeof defaultLogo>;

export type CustomerLogoFile = File;
